import { Component, OnInit} from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { GTMDataLayerService } from 'app/shared/services/gtmDataLayer.service';
import { ConstantsKey } from 'app/shared/constant/constants-keys';

@Component({
  selector: 'support',
  templateUrl: './support.component.html',
})
export class SupportComponent implements OnInit {
 

  public moblieNo = "";

  constructor(private _location: Location,
      public router :  Router,
      public gtmPushService: GTMDataLayerService,) {}
  

  ngOnInit() {
    let consumerData = localStorage.getItem(ConstantsKey.CONSUMER_DATA);
    if(consumerData) {
      consumerData = JSON.parse(consumerData);      
      this.moblieNo = consumerData["mobile"];
    }    
  }

  backClicked() {
    this._location.back();
  }

  supportEvent(supportType) {

    let evtObj = {
      "event": "customer-support",
      "call": supportType == "CALL" ? 'Y' : 'N',
      "email": supportType == "MAIL" ? 'Y' : 'N',
      "service_request": supportType == "SERVICE_REQUEST" ? 'Y' : 'N',
      "customer_feedback": supportType == "FEEDBACK" ? 'Y' : 'N',
      "mobile": this.moblieNo != "" ? "91"+this.moblieNo : ""
    };

    this.gtmPushService.dataLayerPushData(evtObj);


    if(supportType == "CALL") {
      window.open('tel:8976707222');
    } else if(supportType == "MAIL") {
      window.open('mailto:customersupport@wsfx.in');
    } else if(supportType == "SERVICE_REQUEST") {
      this.router.navigate(['/listServiceRequest']);
    } else if(supportType == "FEEDBACK") {
      this.router.navigate(['/customerFeedback']);
    }

  }

}
